import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { Icon } from '@ohif/ui';

import './LoadingIndicatorProgress.css';
import { ProgressBar } from 'primereact/progressbar';
import { Toast } from 'primereact/toast';
import { ProgressService } from '../../service/ProgressService';

/**
 *  A React component that renders a loading indicator.
 * if progress is not provided, it will render an infinite loading indicator
 * if progress is provided, it will render a progress bar
 * Optionally a textBlock can be provided to display a message
 */
function LoadingIndicatorProgress({ className, textBlock, isS3 }) {

  const toastRef = useRef(null);

  const [startGetProgress, setStartGetProgress] = useState(false);
  const [value, setValue] = useState<number>(0);
  const [isViewerImageDicom, setIsViewerImageDicom] = useState(false);
  const [valueMetadata, setValueMetadata] = useState<number>(0);
  const [msgPercentProgress, setMsgPercentProgress] = useState("");
  const progressService = new ProgressService();

  const metaDataDisable = window.config.metaDataDisable;

  const StartProgressDownload = () => {
    const timeStopInerval = 100; // Para evitar ficar dando get em caso de não obter resposta do servidor
    let count = value + 1;
    let checkResponse = 0;
    setValue(0);
    const interval = setInterval(() => {
      let studyInstanceUid = window.location.search.replace("?StudyInstanceUIDs=", "").replace("?", "").trim();
      studyInstanceUid = studyInstanceUid.includes('&') ? studyInstanceUid.split('&')[0] : studyInstanceUid;
      if (studyInstanceUid) {
        const cornerstoneViewportElement = document.getElementsByClassName('cornerstone-viewport-element').length > 0;
        if (checkResponse >= timeStopInerval || cornerstoneViewportElement) {
          setValue(0);
          clearInterval(interval);
        }
        progressService.GetProgress(studyInstanceUid)
          .then(resp => {
            count = resp.data;
            if (count >= 100) {
              setValue(0);
              clearInterval(interval);
              checkResponse = timeStopInerval;
              if (metaDataDisable) {
                getImagesDicomInit().then((result) => {
                  if (result === 0)
                    toastRef.current?.show({ severity: 'error', summary: 'Erro', detail: 'Imagens não liberadas ou não encontradas.', life: 200000 });
                });
              }
            }
            if (count !== 0)
              setValue(Math.round(100 - count));
          })
          .catch(error => {
            clearInterval(interval);
            checkResponse = timeStopInerval;
            return;
          });
        checkResponse++;
      }
    }, 2000);
  };

  const validarUrl = () => {
    const s = `${metaDataDisable && '?'}StudyInstanceUIDs`;
    const _isViewerImageDicom = window.location.search.includes(s);
    setIsViewerImageDicom(_isViewerImageDicom);
  }

  useEffect(() => {
    validarUrl();
    if (metaDataDisable ? isViewerImageDicom : !isViewerImageDicom)
      return;
    if (startGetProgress === false) {
      setStartGetProgress(true);
      StartProgressDownload();
    }
    window.setValueMetadata = (value) => { setValueMetadata(value) };
    window.setMsgPercentProgress = (msg) => { setMsgPercentProgress(msg) }
  }, []);

  return (<div
    className={classNames(
      'absolute z-50 top-0 left-0 flex flex-col items-center justify-center space-y-5',
      className
    )}
  >
    <Toast ref={toastRef} />
    <img src="/layout/logo.png" alt="" style={{ maxHeight: '40px' }} />
    <div className="loading" style={{ height: 'auto', width: '20em' }}>
      {msgPercentProgress && metaDataDisable === false
        ? <ProgressBar mode={valueMetadata == 0 ? 'indeterminate' : 'determinate'} value={valueMetadata} style={{ height: '30px' }}></ProgressBar>
        : <ProgressBar mode={value == 0 ? 'indeterminate' : 'determinate'} value={value} style={{ height: '30px' }}></ProgressBar>}
      <div style={{ backgroundColor: '#040d19', textAlign: 'center', color: '#8dd0ff', padding: '5px', fontSize: '12px' }}>
        {
          metaDataDisable
            ? value < 100 ? `Obtendo imagens dicom ${isS3 ? 'do S3' : ''}` : "Finalizando"
            : !isViewerImageDicom ? "Aguarde" : value < 100 ? "Obtendo imagens dicom" : "Finalizando"
        }
        <span className="loadingProgress"><span></span><span></span><span></span></span>
        <br></br>
        {msgPercentProgress}
      </div>
      {textBlock}
    </div>
  </div>
  );
}
export default LoadingIndicatorProgress;
